<template>
    <wrapper>
        <div class="center" v-if="loading">
            <pre-loader></pre-loader>
        </div>
        <div class="container" v-else>
            <fragment>
                <div class="center" style="margin-top:20px;">
                <h5>{{ data.subject.name }}</h5>
                
                </div>
                
                <div class="row" style="margin-left:100px;" v-show="results.length>0">
                        <div class="card" style="padding:30px;margin-top:50px;">
                            <h5>Total Mark : {{ totalMark }} </h5> <br>
                            <h6>Right Answers</h6>
                            <div class="row" style="padding-left:50px;padding-top:5px;">
                                <div class="row" v-for="item,index in results" v-bind:key="index">
                                        <p>{{ data.exercise_question_group.exercise_questions[index].question }}</p>
                                        <p>Ans : {{ item.rightAnswer.option }} 
                                            <i v-if="item.result" class="material-icons right green-text" style="margin-right:30%;">done</i>
                                            <i v-else class="material-icons right red-text" style="margin-right:30%;">highlight_off</i>
                                        </p>
                                </div>
                            </div>
                        </div>

                </div>
                
                <div class="card" style="margin-top:20px;">
                    <div class="card-header" style="padding:5px;padding-left:20px;">
                        <p>Choose one of the options in the following questions</p>
                    </div>
                
                    <div class="card-content" style="padding-bottom:50px;">
                        <data-row @optionChange="chooseOption" v-for="(item,index) in data.exercise_question_group.exercise_questions" :data="item" :index="index"></data-row>
                    </div>
                    <div class="card-actions" style="padding-bottom:10px;text-align:center;">
                        
                        <loading-btn 
                                        v-if="passTheButton"
                                        v-bind:button_type="'submit'"
                                        v-bind:text="'Submit'"
                                        v-bind:custom_class="'btn'"
                                        @button_click="submitAnswer"
                                    ></loading-btn>
                    </div>
                </div>
                <result v-if="showResultModal" @finish="$router.push('/home')"></result>
            </fragment>
            
            
        </div>
    </wrapper>
</template>
<script>
import DataRow from '@/components/EachExercise/DataRow.vue';
import Result from '@/components/EachExercise/Result';
import { createFormData } from './../../misc/CreateFormData.js';
export default {
    data()
    {
        return {
            answers:[],
            showResultModal:false,
            results:[],
        }
    },
    
    components: 
    {
        "data-row":DataRow,
        "result":Result,
    },
    mounted() {
        this.$store.dispatch("getEachExercise",{id:this.$route.params.id});
  
    },
    
  
    computed: {
        loading()
        {
            return this.$store.getters.exercise_loading;
        },
     
        data()
        {
            return this.$store.getters.exercises;
        },
        passTheButton()
        {
            return parseInt(this.answers.length)==parseInt(this.data.exercise_question_group.exercise_questions.length);
        },
        totalMark()
        {
            var mark=0;
            this.results.map((val)=>{
                if (val.result)
                {
                    mark++;
                }
            })
            return mark;
        }
     
    },
    
    watch: 
    {
        finish(val)
        {
            if (val)
            {
                this.showResultModal=true;
            }
        },
        
            
    },
    methods: {
        chooseOption(data)
        {
            
            if (this.checkInAnswers(data.question_id))
            {
                
                this.answers=this.answers.filter((value)=>{
                    return value.question_id!=data.question_id;
                });
            }
            
            
                this.answers.push(data);
            
        },
        checkInAnswers(question_id)
        {
            
            var result=false;
            this.answers.map((value)=>{
                
                if (parseInt(value.question_id)==parseInt(question_id))
                {
                    result=true;
                }
            });
            return result;
        },
        submitAnswer()
        {
            var questions=this.data.exercise_question_group.exercise_questions;
            this.results=[];
            for (var i=0;i<questions.length;i++)
            {
                var right=false;
                var rightAnswer;
                questions[i].options.map((val)=>{
                    if (val.answer==1)
                    {
                        rightAnswer=val;
                        if (this.answers[i].option_id==val.id)
                        {
                            
                            right=true;
                        }
                    }
                });

                right==true?this.results.push({result:true,rightAnswer:rightAnswer}):this.results.push({result:false,rightAnswer:rightAnswer});
            }

            this.showResultModal=true;
        },
      
    },
}
</script>
<style lang="scss">
    .result_box
    {
        margin-top:150px;

    }

     .result_box .card 
     {
         padding:50px;
         border-radius:30px;
     }
</style>